import { useState, useEffect, useContext } from 'react';
import CommunityDashboard from './CommunityDashboard';
import FirstCommunity from './FirstCommunity';
import { getCommunitiesByUser } from 'utils/requests/communities';
import { TokenContext } from 'context/TokenContext';
import showToast from 'components/Toast/Toast';

const CommunityContainer = () => {
  const { decodedToken } = useContext(TokenContext);
  const [hasCommunity, setHasCommunity] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const checkCommunity = async () => {
    setIsLoading(true);
    try {
      const data = await getCommunitiesByUser(decodedToken.id);
      setHasCommunity(Array.isArray(data) && data.length > 0);
    } catch (error) {
      if (error.status === 404) {
        setHasCommunity(false);
      } else {
        showToast('Erro ao buscar comunidades.', 'error');
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    checkCommunity();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return hasCommunity === true ? (
    <CommunityDashboard onCommunityDeleted={() => setHasCommunity(false)} />
  ) : (
    <FirstCommunity onCommunityCreated={() => setHasCommunity(true)} />
  );
};

export default CommunityContainer;